/**
 * @author       esraa.afifi@zumper.com (Esraa Afifi)
 * @copyright    Copyright (c) 2023, Zumper
 * @description  Get price bound array for ads
 */

const getPriceBounds = (min: number, max: number) => {
  const minNum = Math.floor(min / 1000) * 1000
  const maxNum = Math.floor(max / 1000) * 1000
  return [minNum, maxNum]
}

export const getPriceBoundData = (minPrice: number, maxPrice: number) => {
  const acc = []
  const [lowerBound, upperBound] = getPriceBounds(minPrice, maxPrice)

  for (let i = lowerBound; i <= upperBound; i += 1000) {
    if (i >= 5000) {
      acc.push('5000+')
      break
    }
    acc.push(`${i} - ${i + 1000}`)
  }
  return acc
}

export const getPriceBoundDataArray = (minPrices: number[], maxPrices: number[]) => {
  const prices: string[] = []
  for (let i = 0; i < minPrices.length; i++) {
    const minPrice = minPrices[i]
    const maxPrice = maxPrices[i]
    const priceBound = getPriceBoundData(minPrice, maxPrice)
    prices.push(...priceBound)
  }
  return prices.filter((price, index) => prices.indexOf(price) === index)
}
